export default __webpack_public_path__ + "static/media/settings.35a421c4.svg";